module.exports = __webpack_public_path__ + "media/D.8779d785.wav";